import React from 'react';
import { Switch } from '@headlessui/react';
import { ShieldCheckIcon } from '@heroicons/react/24/outline';

const PermisosTable = (props) => {
    const { permisos, permisosSelected, setPermisosSelected } = props;

    const handlePermiso = (permisoName, isEnabled) => {
        console.log("permisos seleccionados", permisosSelected);
        console.log("permiso", permisoName, "enabled:", isEnabled);
        
        if (isEnabled) {
            setPermisosSelected(prevArray => [...prevArray, permisoName]);
        } else {
            let temporal = permisosSelected.filter(p => p !== permisoName);
            setPermisosSelected(temporal);
        }
    }

    return (
        <div className="space-y-3">
            {permisos.map((permiso) => {
                const isChecked = permisosSelected.indexOf(permiso.name) >= 0;
                
                return (
                    <div
                        key={permiso.id}
                        className="flex flex-col md:flex-row md:items-center gap-3 p-3 bg-white rounded-lg border border-gray-200 hover:border-gray-300 transition-colors"
                    >
                        {/* Nombre del permiso */}
                        <div className="flex items-center gap-2 md:w-1/4">
                            <ShieldCheckIcon className="w-5 h-5 text-gray-400 shrink-0" />
                            <span className="text-sm font-medium text-gray-900">
                                {permiso.name}
                            </span>
                        </div>

                        {/* Descripción */}
                        <div className="md:flex-1 text-sm text-gray-600">
                            {permiso.description}
                        </div>

                        {/* Switch de activación */}
                        <div className="flex items-center justify-end md:w-32">
                            <Switch
                                checked={isChecked}
                                onChange={(checked) => handlePermiso(permiso.name, checked)}
                                className={`${
                                    isChecked ? 'bg-blue-600' : 'bg-gray-300'
                                } relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2`}
                            >
                                <span className="sr-only">
                                    {isChecked ? 'Desactivar' : 'Activar'} permiso
                                </span>
                                <span
                                    className={`${
                                        isChecked ? 'translate-x-6' : 'translate-x-1'
                                    } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
                                />
                            </Switch>
                            <span className="ml-2 text-xs font-medium text-gray-700">
                                {isChecked ? 'SÍ' : 'NO'}
                            </span>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default PermisosTable;